import {BaseData} from '@/_model/base-data';
import {PersonData} from '@/_model/person-data';
import {EnumPermission} from '@/_model/user-data';

export enum UserType {
  Admin = 1 << 0,
  User = 1 << 1
}

export type TypeUser = { label: string, value: UserType };
export type TypeUserList = { [key: string]: TypeUser };

export class AppData extends BaseData {
  static UserTypes: TypeUserList =
    {
      admin: {label: $localize`Admin`, value: UserType.Admin},
      user: {label: $localize`User`, value: UserType.User}
    }

  usertype: UserType;
  permissions: number[];
  person: PersonData;

  constructor(json?: any) {
    super(json);
  }

  override get _asJson(): any {
    return {
      a: this.person.asJson,
      // b: this.mapArrayToJson(this.counters),
    };
  }

  override _fillFromJson(json: any, def?: any): void {
    this.person = new PersonData(json?.a ?? def?.person);
    // this.counters = this.mapArrayToModel(json?.b ?? def?.counters, CounterData);
    // this.counters?.sort((a, b) => {
    //   return Utils.compare(a.id, b.id);
    // })
  }

  may(perm: EnumPermission): boolean {
    return this.usertype === UserType.Admin || this.permissions?.indexOf(perm) >= 0;
  }
}
